import * as user from './user';
import * as organization from './organization';
import * as application from './application';
import * as enrollment from './enrollment';

export default {
  user,
  organization,
  application,
  enrollment,
};
